import { fg } from '@confluence/feature-gating';

export const isEmojiTitleEnabled = (contentType: string | null | undefined): boolean => {
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	return contentType === 'whiteboard' && fg('confluence_frontend_whiteboard_emoji_titles');
};
